import validate from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  cupons: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/middleware/cupons.ts"),
  pedidos: () => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/middleware/pedidos.ts")
}